<template>
  <div>
    <List
      url="sre-api/deviceoffline/result/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      :useBatchSuffix="false"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Filter">
      <el-row :gutter="20">
        <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
          <el-button @click="statistics" type="primary" style="margin-right:10px;">监控数据图表</el-button>
        </el-col>
      </el-row>
      </div>

      <div slot="Fresh" style="float:right;">
        <label>云平台：</label>
          <el-select multiple v-model="selectClouds" @change="search" placeholder="请选择云平台(多选)" style="width:180px;margin-right:10px;" size="small">
            <el-option
              v-for="cloud in cloudEnvList"
              :label="cloud"
              :key="cloud"
              :value="cloud"></el-option>
          </el-select>
          <el-input v-model="searchData.dis" @change="search" size="small" style="width:140px;margin-right:10px;" placeholder="请输入Dis账号"></el-input>
          <el-input v-model="searchData.ins" @change="search" size="small" style="width:140px;margin-right:10px;" placeholder="请输入Ins账号"></el-input>
          <el-input v-model="searchData.location" @change="search" size="small" style="width:140px;margin-right:10px;" placeholder="请输入社区名称"></el-input>
          <el-input v-model="searchData.mac" @change="search" size="small" style="width:140px;margin-right:10px;" placeholder="请输入设备MAC"></el-input>
          <el-input v-model="searchData.firmware" @change="search" size="small" style="width:140px;margin-right:10px;" placeholder="请输入固件版本"></el-input>

          <el-select v-model="selectStatus" placeholder="请选择在线状态" @change="search" style="width:100px;margin-right:10px;" size="small">
            <el-option value="全部" label="全部"></el-option>
            <el-option
              v-for="status in deviceStatus"
              :label="status"
              :key="status"
              :value="status"></el-option>
          </el-select>

          <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>

      <template v-slot:slot-status="scope" >
        <el-tag :type="scope.item.statusOriginValue ? 'success' : 'danger'">{{ scope.item.status }}</el-tag>
      </template>
    </List>
  </div>
</template>

<script>
import { DeviceStatus } from "../components/Index/data.js";
import List from "../components/common/List.vue";

export default {
  components: {
    List
  },
  data() {
    return {
      selectDevices: [],
      cloudEnvList: [],  // 从后端获取的 cloud 列表
      selectClouds: [],
      selectStatus: "全部",
      deviceStatus: DeviceStatus,
      title: "设备监控-监控结果",
      tanle: [
        { name: "create_time", label: "监控时间" },
        { name: "cloud", label: "云平台" },
        { name: "mac", label: "设备MAC" },
        { name: "status", label: "在线状态" },
        { name: "firmware", label: "固件版本" },
        { name: "dis", label: "dis账号" },
        { name: "ins", label: "ins账号" },
        { name: "location", label: "社区名称" },
        { name: "lastconnection", label: "最近一次连接时间" },
      ],
      searchData: {
        cloud: "",
        mac: "",
        firmware: "",
        dis: "",
        ins: "",
        location: "",
        status: ""
      },
      operation: [],
      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchCloudEnvs();
  },
  methods: {
    statistics(){
      window.open("http://grafana.akuvox.com/d/db19461e-2812-42db-bbbb-3ed3ea9b8160/e8aebe-e5a487-e7a6bb-e7babf-e79b91-e68ea7");
    },
    dealList(data) {
      for (let i in data) {
        data[i].create_time = this.changeDate(data[i].create_time);
        data[i].lastconnection = this.changeDate(data[i].lastconnection);
        data[i].statusOriginValue = data[i].status;
        data[i].status = data[i].status ? "在线" : "离线";
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    add() {
      this.updateType = "add";
      this.updateForm = {};
      this.updateBlock = true;
    },
    edit(val) {
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
      this.updateBlock = true;
    },
    search() {
      this.searchData.device_name = this.selectDevices.join(",");
      this.searchData.cloud = this.selectClouds.join(",");
      if (this.selectStatus === '全部') {
        this.searchData.status = "";
      } else {
        this.searchData.status = +(this.selectStatus === '在线');
      };
      this.updateList++;
    },
    deletedata(val) {
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = "sre-api/deviceoffline/result/" + val.id + "/";
        this.$http["delete"](url,
          () => {
            this.$baseNotice.message("删除成功");
            this.updateList++;
          },
          () => {
            this.$message({message: "删除失败", type: "error"});
          }
        );
      }).catch(() => {
        this.$message({message: "已取消删除", type: "warning"});
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchCloudEnvs() {
      this.$http["get"](
        "cloud/env/", {}, (data) => {
          this.cloudEnvList = data.data.results.map(item => item.cloud);
        }
      );
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
